module.exports = __webpack_public_path__ + "static/exana-7bb1895758b5db9b1ed3beb994c478f0.png";